import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AuthGuard } from './core/guards/auth.guard';
import { NewUserAccessGuard } from './core/guards/new-user-access.guard';
import { UserAccessGuard } from './core/guards/user-access.guard';
import { LayoutComponent } from './layouts/layout.component';

const routes: Routes = [
  {
    path: 'account',
    loadChildren: () =>
      import('./account/account.module').then((m) => m.AccountModule),
  },
  // {  
  //   path: 'auction2',
  //   component: LayoutComponent,
  //   loadChildren: () =>
  //   import('./auction2/auction2.module').then((m) => m.Auction2Module), canActivate: [AuthGuard],
  // },
  {
    path: '', redirectTo: 'epp', pathMatch: 'full'
  },
  {
    path: '**', redirectTo: 'user  ', pathMatch: 'full'
  },
  {
    path: 'epp', component: LayoutComponent, loadChildren: () => import('./epp/epp.module').then((m) => m.EppModule), canActivate: [AuthGuard, UserAccessGuard]
  },
  {
    path: 'tp', component: LayoutComponent, loadChildren: () => import('./tp/tp.module').then((m) => m.TpModule), canActivate: [AuthGuard, UserAccessGuard]
  },
  {
    path:'lrs', component:LayoutComponent, loadChildren: () => import('./lrs/lrs.module').then((m) => m.LrsModule), canActivate: [AuthGuard,UserAccessGuard]
  },
  {
    path:'auction-alert', component:LayoutComponent, loadChildren: () => import('./auction-alert/auction-alert.module').then((m) => m.AuctionAlertModule), canActivate: [AuthGuard,UserAccessGuard]
  },

  {
    path:'area-alert', component:LayoutComponent, loadChildren: () => import('./area-alert/area-alert.module').then((m) => m.AreaAlertModule), canActivate: [AuthGuard,UserAccessGuard]
  },
  {
    path:'survey-alert', component:LayoutComponent, loadChildren: () => import('./survey-alert/survey-alert.module').then((m) => m.SurveyAlertModule), canActivate: [AuthGuard,UserAccessGuard]
  },
  {
    path: 'deo', component: LayoutComponent, loadChildren: () => import('./deo/deo.module').then((m) => m.DeoModule), canActivate: [AuthGuard, UserAccessGuard]
  },
  {
    path: 'user', component: LayoutComponent, loadChildren: () => import('./user/user.module').then((m) => m.UserModule), canActivate: [AuthGuard, UserAccessGuard]
  },
  {
    path: 'new-user', component: LayoutComponent, loadChildren: () => import('./new-user-dashboard/new-user-dashboard.module').then((m) => m.NewUserDashboardModule), canActivate: [AuthGuard]
  },
  {
    path: 'users', component: LayoutComponent, loadChildren: () => import('./franchise/franchise.module').then((m) => m.FranchiseModule),
  },


  {
    path: 'auction',
    component: LayoutComponent,
    loadChildren: () =>
      import('./auction/auction.module').then((m) => m.AuctionModule), canActivate: [AuthGuard]
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'top' })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
